module.exports = __webpack_public_path__ + "static/media/433391913_949385776809476_3252605833067849439_n.d65cedd1.jpg";